module.exports = __webpack_public_path__ + "static/img/King of Cups.d2fd47f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/King of Cups.jpg
// module id = 1275
// module chunks = 0